export const getErrorText = (errorArr, errorKey) => {
  let errorText = errorArr.filter((item) => item.key === errorKey);
  return errorText[0].message;
};
